import { Component, OnInit, Input } from '@angular/core';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { fuseAnimations } from '@fuse/animations';

@Component({
  selector: 'app-common-violations',
  templateUrl: './common-violations.component.html',
  styleUrls: ['./common-violations.component.scss'],
  animations: fuseAnimations
})
export class CommonViolationsComponent implements OnInit {

  @Input() violationsData: any;
  @Input() mode: string;
  @Input() sDate: any;
  profileId = '';
  violationResults = [];
  roles = [];
  violationsForm: FormGroup;

  constructor(
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private toastr: ToastrService,

  ) { }

  ngOnInit() {
    
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    let results = [];
    this.violationsData.forEach(element => {
      let userName = element.userProfileId.get('firstName') + ' ' + element.userProfileId.get('lastName');
      let role = element.userProfileId.get('role').get('name');
      let inTimeValue = element.violations.filter(a => a.type == 'In-Time')[0];
      inTimeValue = inTimeValue == undefined ? '' : inTimeValue;

      let incompleteHrsValue = element.violations.filter(a => a.type == 'Incompleted-Hours')[0];
      incompleteHrsValue = incompleteHrsValue == undefined ? '' : incompleteHrsValue;

      let breakHrsValue = element.violations.filter(a => a.type == 'Exceeded-Break-Hours')[0];
      breakHrsValue = breakHrsValue == undefined ? '' : breakHrsValue;

      results.push({
        userName, role,
        outTime: incompleteHrsValue.inCompletedHours,
        inTime: inTimeValue.inTime,
        id: element.objectId,
        date: element.violatedDate,
        status: element.status,
        startTime: element.startTime,
        breakHrs: breakHrsValue.exceededHours,
        isResolved: element.isResolved,
        inTimeReason: inTimeValue.reason == undefined ? '' : inTimeValue.reason,
        incompletedHrsReason: incompleteHrsValue.reason == undefined ? '' : incompleteHrsValue.reason,
        breakHrsReason: breakHrsValue.reason == undefined ? '' : breakHrsValue.reason
      });
    });
    this.violationResults = results;

  }

  resolve(event, type) {
    let data;

    if (event.inTimeReason == '' && event.inTime != '' && event.inTime != undefined) {
      this.toastr.warning('In Time Reason is required!!');
      return true;
    }
    if (event.incompletedHrsReason == '' && event.outTime != '' && event.outTime != undefined) {
      this.toastr.warning('Incompleted Hours Reason is required!!');
      return true;
    }
    if (event.breakHrsReason == '' && event.breakHrs != '' && event.breakHrs != undefined) {
      this.toastr.warning('Break Hours Reason is required!!');
      return true;
    }

    this.violationsData.forEach(s => {
      if (s.objectId == event.id) {
        s.violations.forEach(element => {
          if (element.type == 'In-Time') {
            element.reason = event.inTimeReason;
          }
          if (element.type == 'Incompleted-Hours') {
            element.reason = event.incompletedHrsReason;
          }
          if (element.type == 'Exceeded-Break-Hours') {
            element.reason = event.breakHrsReason;
          }
        });
        s.status = type;
      }
    });

    data = this.violationsData.filter(s => s.objectId == event.id)[0];
    this.queryInterface.executeQuery(this.parseService, 'UserViolations', [{ condition: 'equalTo', field: 'objectId', value: event.id }]).then(results => {
      var result = results[0];
      result.set('violations', data.violations);
      result.set('resolvedBy', {
        __type: 'Pointer',
        className: 'Profile',
        objectId: this.profileId
      });
      result.set('status', type);
      result.set('resolvedDate', new Date());
      result.save().then((data) => {
        this.ngOnInit();
        let status;
        status = this.violationsData.filter(a => a.status == 'open');
        this.toastr.success('Violation Saved Successfully');
        if (status.length > 0) {
          this.toastr.warning('Please resolve pending violations');
        }
        // this.router.navigate(['team-violation', { date: this.sDate }]);
      }
      );
    });
  }


}
